import { Navigate } from 'react-router-dom';

import { CandidatesPage } from '@pages';
import { AppRoutes, hasPermission } from '@constants';
import { useAppSelector } from '@redux/hooks';
import { selectPermissions } from '@redux/accounts';

export const CandidatesRoute = () => {
  const permissions = useAppSelector(selectPermissions);
  const arePermissionsLoading = useAppSelector(
    (state) => state.accounts.loading,
  );

  if (
    !arePermissionsLoading &&
    !hasPermission(permissions, 'H:R') &&
    hasPermission(permissions, 'N:R')
  )
    return <Navigate to={`/${AppRoutes.AVAILABLE_CANDIDATES}`} replace />;

  return <CandidatesPage />;
};
